<div class="title-bar">
    <span class="title">Payment Acknwoledgement</span>
    <button mat-icon-button >
        <mat-icon>close</mat-icon>
      </button>
</div>
